import { createFileRoute } from "@tanstack/react-router";
import { SqlHistoricoPage } from "@/paginas/sql-historico";

const TITULO = "Histórico SQL — Milky Moo Palmares";
const DESCRICAO =
  "Consulta dos comandos SQL registrados no sistema, com filtros por período e por texto.";

export const Route = createFileRoute("/_authenticated/sql-historico")({
  head: () => ({
    meta: [
      { title: TITULO },
      { name: "description", content: DESCRICAO },
      { property: "og:title", content: TITULO },
      { property: "og:description", content: DESCRICAO },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: SqlHistoricoPage,
});
